module.exports = __webpack_public_path__ + "img/gb9115_15.prt.ba475dbc.jpg";